import './style.scss';

export default (message, btnClose) => (
  `
    <div class="xpi__modal">
      <section class="xpi__modal__content">
        <div class="xpi__modal__content__text">${message}</div>
      </section>
      ${btnClose ? `<div class="xpi__modal__close">X</div>` : ``}
    </div>
  `
);
